export function PercentIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M20.707 3.293a1 1 0 010 1.414l-16 16a1 1 0 01-1.414-1.414l16-16a1 1 0 011.414 0z"
      ></path>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3 7c0-2.03 1.404-4 3.5-4S10 4.97 10 7c0 2.03-1.404 4-3.5 4S3 9.03 3 7zm3.5-2C5.835 5 5 5.717 5 7s.835 2 1.5 2S8 8.283 8 7s-.835-2-1.5-2zM17.5 13c-2.096 0-3.5 1.97-3.5 4 0 2.03 1.404 4 3.5 4s3.5-1.97 3.5-4c0-2.03-1.404-4-3.5-4zM16 17c0-1.283.834-2 1.5-2s1.5.717 1.5 2-.834 2-1.5 2-1.5-.717-1.5-2z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
